import { BehaviorSubject } from 'rxjs';

export default class CreatePasswordBloc {
  submitButtonError$ = new BehaviorSubject(null);
  termsCheck$ = new BehaviorSubject(false);
  buttonError$ = new BehaviorSubject(null);

  constructor({ authRepository, userRepository }) {
    this.authRepository = authRepository;
    this.userRepository = userRepository;
  }

  updateTermsCheck(target, state) {
    this.updateButtonError(null);
    if (target === 'terms') this.termsCheck$.next(state);
  }

  updateButtonError(message) {
    this.buttonError$.next(message);
  }

  validateRequiredField() {
    const termsCheck = this.termsCheck$.getValue();
    if (!termsCheck) {
      this.updateButtonError('Please accept the terms and conditions to proceed.');
      return false;
    }

    return true;
  }

  async validateInviteToken(token) {
    await this.authRepository.validateInviteToken(token);
  }

  async validateForgotToken(token) {
    await this.authRepository.validateForgotToken(token);
  }

  async setForgotPassword(token, password, shouldLogin) {
    try {
      if (shouldLogin) {
        this.userRepository.setIsPatientDashboardTourShown(1);
        this.userRepository.removeShouldRunSelfHelpJoyride();
        this.userRepository.removeIsPatientDemoAccount();
      }

      await this.authRepository.setForgotPassword(token, password, shouldLogin);
    } catch (error) {
      if (error.status === 409 || error.statusCode === 409) {
        this.updateButtonError('New password must be different from your current password.');
        throw error;
      }

      this.updateButtonError('Failed to reset password. Please try again.');
      throw error;
    }
  }
}
